import React from 'react';
import { useTable, useFlexLayout } from 'react-table'
import "./style/TableWidget.css"

const TableWidget = function (props) {

    const { columns, data } = props;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data, useFlexLayout })


    return (
        <table {...getTableProps()} className="w-100 table-hover">
            <thead>{
                headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps(props.headerGroupProps)}>{
                        headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.props)}>{
                                column.render('Header')
                            }</th>
                        ))
                    }</tr>
                ))
            }
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row);
                    return (
                        <tr {...row.getRowProps(props.rowProps)}>{
                            row.cells.map(cell => {
                                return (
                                    <td {...cell.getCellProps()}>{
                                        cell.render('Cell')
                                    }</td>
                                )
                            })
                        }</tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default TableWidget;